// extracted by mini-css-extract-plugin
module.exports = {"statusTextHolder":"PresenterMicStatusText_statusTextHolder__3cbt6","statusTextHolderBackstage":"PresenterMicStatusText_statusTextHolderBackstage__2ng-y"};